const translations = {
    acres: 'ac',
    activity: 'Activity',
    applicationComplete: 'Application Complete',
    applicationStarted: 'Application Started',
    duration: 'duration',
    flight: 'Flight',
    gallons: 'gal',
    minutes: 'mins',
    noActivity: 'No activity'
};

export default translations;
